import { mapKeys, camelCase } from 'lodash'
import ReportBasicSalaryHistory from '@/api/hr/report-basic-salary-history'
import OrgChartStructure from '@/api/hr/org-chart-structure'
import { baseState, baseMutations, Pagination } from '@/store/mixins'

export const state = {
  ...baseState,
  orgChartStructures: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_RESOURCES(state, records) {
    const { data, ...meta } = records
    state.resources = data
    state.pagination = new Pagination(mapKeys(meta, (v, k) => camelCase(k)))
  },

  RECEIVE_ORG_CHART_STRUCTURES(state, data) {
    state.orgChartStructures = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page || 1,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        ...context.state.queryBuilder
      },
      attributes
    )

    return ReportBasicSalaryHistory.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response.data)
      return Promise.resolve(response)
    })
  },

  fetchOrgStructures(context) {
    return OrgChartStructure.get({
      params: {
        page: -1,
        fields: {
          hris_org_chart_structure: 'org_chart_structure_id,org_chart_structure'
        }
      }
    }).then(response => {
      context.commit('RECEIVE_ORG_CHART_STRUCTURES', response.data)
      return Promise.resolve(response)
    })
  },

  exportExcel(context, { ...attributes }) {
    return ReportBasicSalaryHistory.exportExcel(attributes)
  },

  exportPdf(context, { ...attributes }) {
    return ReportBasicSalaryHistory.exportPdf(attributes)
  }
}
